import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/database";

// Your web app's Firebase configuration
var firebaseConfig = {
  apiKey: "AIzaSyCkQE4dyZGHj2byujtMGznewl6E3JCqORI",
  authDomain: "livetour-52cbd.firebaseapp.com",
  databaseURL: "https://livetour-52cbd.firebaseio.com",
  projectId: "livetour-52cbd",
  storageBucket: "livetour-52cbd.appspot.com",
  messagingSenderId: "567449423825",
  appId: "1:567449423825:web:4fd270df355118e3575af0",
};

firebase.initializeApp(firebaseConfig);
export default firebase;
export const auth = firebase.auth();
export const firestore = firebase.firestore();

export const GetPropertiesFromFirebase = async (hostId) => {
  const snapshot = await firestore
    .collection("properties")
    .where("hostId", "==", hostId)
    .get();
  const properties = snapshot.docs.map((doc) => doc.data());
  if (properties.length) {
    return properties;
  } else {
    return null;
  }
};

export const GetUnitsFromFirebase = async (apartmentId) => {
  if (!apartmentId) return;
  const snapshot = await firestore
    .collection(`properties/${apartmentId}/units`)
    .get();
  const units = snapshot.docs.map((doc) => doc.data());

  if (units.length) {
    return units;
  } else {
    return null;
  }
};

export const GetViewsFromFirebase = async (apartmentId, unitId) => {
  if (!unitId || !apartmentId) return;
  const snapshot = await firestore
    .collection(`properties/${apartmentId}/units/${unitId}/views`)
    .get();
  const views = snapshot.docs.map((doc) => doc.data());

  if (views.length) {
    return views;
  } else {
    return null;
  }
};

export const GetHostFromFirebase = async (id) => {
  if (!id) return;
  const trimmedId = id.trim();
  const docRef = firestore.doc(`users/${trimmedId}`);
  const userRef = await docRef.get();
  if (userRef && userRef.exists) {
    const host =
      userRef.data().accountType === "host" ? userRef.data().name : null;
    return host;
  } else {
    console.log("DOES NOT EXIST");
    return null;
  }
};

export const StartRoomInRealTime = async (roomName, hostName) => {
  if (!roomName) return;
  const database = firebase.database();
  const hostRef = database.ref(`rooms/${roomName}/host/`);
  var hostKey = hostRef.push().key;
  var updates = {};
  updates[`rooms/${roomName}/host/${hostKey}`] = hostName;
  firebase.database().ref().update(updates);
  return hostKey;
};

export const GuestJoinInRealTime = async (roomName, guestName) => {
  if (!roomName) return;
  const database = firebase.database();
  const guestRef = database.ref(`rooms/${roomName}/guest/`);
  var guestKey = guestRef.push().key;
  var updates = {};
  updates[`rooms/${roomName}/guest/${guestKey}`] = guestName;
  firebase.database().ref().update(updates);
  return guestKey;
};

export const RemoveUserInRealTime = async (roomName, userKey) => {
  const { user, key } = userKey;
  const userType = user === "host" ? "host" : "guest";
  console.log(userType);
  const database = firebase.database();
  database.ref(`/rooms/${roomName}/${userType}/${key}`).remove();

  if (userType === "host") {
    database.ref(`/rooms/${roomName}/selectedUnitUrl/`).remove();
    database.ref(`/rooms/${roomName}/imageUrl/`).remove();
    database.ref(`/rooms/${roomName}/apartmentName/`).remove();
  }
};

export const SubmitPropertyDetailsInRealTime = async (
  roomName,
  apartmentId,
  apartmentName
) => {
  const database = firebase.database();
  database.ref(`/rooms/${roomName}/`).child("apartmentId").set(apartmentId);
  database.ref(`/rooms/${roomName}/`).child("apartmentName").set(apartmentName);
  database.ref(`/rooms/${roomName}/unitId/`).remove();
};

export const SubmitUnitDetailsInRealTime = async (roomName, unitId) => {
  const database = firebase.database();
  database.ref(`/rooms/${roomName}/`).child("unitId").set(unitId);
};

export const SubmitPropertyImagePreviewInRealTime = async (
  roomName,
  imageUrl
) => {
  const database = firebase.database();
  database.ref(`/rooms/${roomName}/`).child("imageUrl").set(imageUrl);
};

export const SubmitSelectedUnitUrlInRealTime = async (
  roomName,
  selectedUnitUrl
) => {
  const database = firebase.database();
  database
    .ref(`/rooms/${roomName}/`)
    .child("selectedUnitUrl")
    .set(selectedUnitUrl);
};

export const RemoveSelectedUnitUrlInRealTime = async (roomName) => {
  const database = firebase.database();
  database.ref(`/rooms/${roomName}/selectedUnitUrl/`).remove();
};

export const RemoveSelectedUnitIdInRealTime = async (roomName) => {
  const database = firebase.database();
  database.ref(`/rooms/${roomName}/unitId/`).remove();
};
